module.exports = __webpack_public_path__ + "static/media/home.351d8768.svg";